import React, { useState, useEffect, useContext, useRef } from "react";
import Table from "../Homepage/Table";
import "../../css_files/Master/HSNMaster.css";
import AddHSNMaster from "./AddHSNMaster";
import SearchHSNMaster from "./SearchHSNMaster";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";

function HSNMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = ["Id", "HSN Code", "Description"];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [hsnupdatedata, sethsnupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const [loading, setloading] = useState(false);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [excelloading, setexcelloading] = useState(false);
  const [totalcount, setTotalCount] = useState(0);
  const [hsnId, sethsnId] = useState(null);
  const [search, setSearch] = useState("");
  const [Ids, setIds] = useState([]);

  function fetchhsndata(hsnid) {
    sethsnupdatedata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/v1/HSN/GetHSNByIdOrCode?id=${hsnid}&page=1`;
    axiosInstance
      .get(url)
      .then((res) => {
        sethsnupdatedata(res.data.data[0]);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setloading(true);
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/hsn/${pagenumber}`;
    axiosInstance
      .post(URL, {
        Id: hsnId || null,
        Search: search,
        Ids,
      })
      .then((response) => {
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [x.id, x.hsnCode, x.description])
        );
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [reload, pagenumber, Ids.length]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "HSN" && x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "HSN" && x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "HSN" && x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "HSN" && x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="hsn-master">
      <h1>HSN Master</h1>
      <blockquote className="hsn-master-forms">
        <AddMaster
          text="Add HSN Master"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={writePermission}
        />

        <SearchMaster
          text="Search HSN Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddHSNMaster
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          hsnupdatedata={hsnupdatedata}
          key={`${hsnupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchHSNMaster
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setIds={setIds}
          setHSNId={sethsnId}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}
      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchhsndata}
        url="HSN/UpdateHSN"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={readPermission}
        updatePermission={updatePermission}
        deletePermission={deletePermission}
        totalcount={totalcount}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
    </section>
  );
}

export default HSNMaster;
